import script from "./CandidateSelect.vue?vue&type=script&setup=true&lang=ts"
export * from "./CandidateSelect.vue?vue&type=script&setup=true&lang=ts"

import "./CandidateSelect.vue?vue&type=style&index=0&id=c194d4ca&scoped=true&lang=scss"
import "./CandidateSelect.vue?vue&type=style&index=1&id=c194d4ca&lang=scss"

import exportComponent from "/home/jenkins/agent/workspace/K8S-上海阿里云Prod环境-UOTS-Front/frontend/front-uots-simulator/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-c194d4ca"]])

export default __exports__